// eslint-disable-next-line import/no-unresolved
import { useIsAuthenticated } from '@creditsights/navbar-web';
import { Loader } from '@creditsights/styleguide-web';
import { useQueryClient } from '@tanstack/react-query';
import { ReactElement } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ROUTES } from './Base.constants';
import useFetchUserPermissions from './hooks/permissions/useFetchUserPermissions';
import RPCalculator from './pages/RPCalculator';

const Base = (): ReactElement => {
  const queryClient = useQueryClient();
  const { isAuthenticated } = useIsAuthenticated(queryClient);
  const { isLoading: isPermissionsLoading } = useFetchUserPermissions(isAuthenticated);

  if (!isAuthenticated) {
    // eslint-disable-next-line no-restricted-globals
    location.href = ROUTES.login;
  }

  if (isPermissionsLoading) {
    return <Loader text={null} className="loader-container" />;
  }

  return (
    <Router>
      <Routes>
        <Route path={ROUTES.rpCalculator} element={<RPCalculator />} />
      </Routes>
    </Router>
  );
};

export default Base;
